import React from 'react';
import { EditorState, ContentState } from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import { stateFromHTML } from 'draft-js-import-html';
import htmlToDraft from 'html-to-draftjs';

const getInitialEditorState = (initialValue) => {
  try {
    const blocksFromHtml = htmlToDraft(initialValue || '<p></p>');
    const { contentBlocks, entityMap } = blocksFromHtml;
    const contentState = ContentState.createFromBlockArray(
      contentBlocks,
      entityMap,
    );
    return EditorState.createWithContent(contentState);
  } catch (err) {
    console.log(`AQUI ERROR: ${err}`);
    return EditorState.createWithContent(stateFromHTML(initialValue));
  }
};

const Rendered = ({ html, ...props }) => {
  //const editorState = getInitialEditorState(html);
  const fontStyles = `
    @font-face {
      font-family: 'CircularStd-Book';
      src: url('/assets/fonts/CircularStd-Book.woff2') format('woff2'),
          url('/assets/fonts/CircularStd-Book.woff') format('woff');
      font-weight: normal;
      font-style: normal;
    }
    * {
      font-family: 'CircularStd-Book', sans-serif !important;
    }
  `;

  // Combinamos los estilos con el HTML
  const htmlWithStyles = `
    <style>${fontStyles}</style>
    ${html}
  `;
  return (
      <>
        {/*<iframe
        className={`iframe-class ${props.className}`}
        srcDoc={htmlWithStyles} 
        width="100%"
        height="500px"
        style={{ border: 'none' }}
        title="Iframe Title"
      ></iframe>*/}
         <Editor
          {...props}
          toolbar={{
            options: [],
          }}
          readOnly
          className={props.className}
          editorClassName="my-circular-editor"
          editorState={getInitialEditorState(html)}
        /> 
      </>
  );
};

export default Rendered;
